export const extractJsonObject = (text)=> {
    if (typeof text !== "string") {
        throw new Error("Input must be a string");
    }

    const matches = text.match(/\{[\s\S]*\}/g);
    if (!matches) {
        throw new Error("No JSON object found in the text");
    }

    for (const block of matches) {
        try {
            const obj = JSON.parse(block);
            if (obj && typeof obj === "object") {
                return obj;
            }
        } catch (e) {
        }
    }

    throw new Error("Found JSON-like blocks, but none were valid JSON");
}
